var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('home',{directives:[{name:"show",rawName:"v-show",value:(_vm.connect == false),expression:"connect == false"}],staticStyle:{"height":"100vh"}}),_c('mouse',{directives:[{name:"show",rawName:"v-show",value:(_vm.connect),expression:"connect"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }